import React, { Component } from "react";
import { Bar } from "react-chartjs-2";
import "react-datepicker/dist/react-datepicker.css";
import { DateRangePicker } from "react-dates";
import { connect } from "react-redux";
import MediaQuery from "react-responsive";
import Select from "react-select";
import {
  Alert,
  Card,
  CardBody,
  CardHeader,
  Col,
  Collapse,
  Label,
  Row,
} from "reactstrap";
import { bindActionCreators } from "redux";
import { layout, messages, roles } from "../../../../common/constants";
import { DataTable, ExportCSV } from "../../../../components";
import { getAverageTicket as averageTicketExport } from "../../../../service/dashboard";
import { getAverageTicket } from "../../../../store/dashboard/actions";
import { selectAverageTicketData } from "../../../../store/dashboard/selector";
import { getStores } from "../../../../store/store/actions";
import { selectStoresForSelect } from "../../../../store/store/selector";
import { selectUserRole } from "../../../../store/user/selector";
import { exportExcel } from "./excel";
import * as charts from "./_charts";
import * as columns from "./_columns";

class CardAverageTicket extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showAverageTicket: true,
      startDate: null,
      endDate: null,
      focusedInput: null,
      loadingExport: false,
      selectedStore: null,
    };
    this.handleObtainSalesExport = this.handleObtainSalesExport.bind(this);
  }

  renderDataTable(columns) {
    if (this.props.averageTicket)
      return (
        <DataTable
          data={this.props.averageTicket}
          keyField="id"
          columns={columns}
          loading={this.props.loading}
        />
      );
  }

  async handleStoreChange(value) {
    if (value == this.state.selectedStore) return;
    await this.setState({ selectedStore: value, page: 1 });
    if (
      this.state.startDate &&
      this.state.endDate &&
      this.state.selectedStore
    ) {
      await this.props.getAverageTicket({
        startDate: this.state.startDate._d,
        endDate: this.state.endDate._d,
        store: this.state.selectedStore.value,
      });
    }
  }

  async componentDidMount() {
    await this.props.getStores({ reset: true });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.stores.length == 0 && this.props.stores.length > 0) {
      this.setState({ selectedStore: this.props.stores[0] });
    }
  }

  handleDateChange(startDate, endDate) {
    this.setState({ startDate, endDate });
    if (startDate != null && endDate != null && this.state.selectedStore) {
      this.props.getAverageTicket({
        startDate: startDate._d,
        endDate: endDate._d,
        store: this.state.selectedStore.value,
      });
    }
  }

  async handleObtainSalesExport() {
    const { startDate, endDate, selectedStore } = this.state;
    this.setState({ loadingExport: true });
    averageTicketExport(startDate._d, endDate._d, selectedStore.value).then(
      (response) => {
        this.setState({ loadingExport: false });
        exportExcel(response.data.data, selectedStore, startDate, endDate);
      }
    );
  }
  render() {
    const { startDate, endDate, loadingExport } = this.state;
    return (
      <Card>
        <CardHeader
          onClick={() =>
            this.setState({ showAverageTicket: !this.state.showAverageTicket })
          }
        >
          Ventas Promedio
        </CardHeader>
        <Collapse isOpen={this.state.showAverageTicket}>
          <CardBody>
            <MediaQuery minDeviceWidth={layout.SM_MIN_WIDTH}>
              {(matches) => {
                if (matches) {
                  return (
                    <div>
                      <Row className="mb-2">
                        <Col md="4">
                          <DateRangePicker
                            startDate={startDate}
                            startDateId="startDate"
                            endDate={endDate}
                            endDateId="endDate"
                            displayFormat={"DD/MM/YYYY"}
                            onDatesChange={({ startDate, endDate }) =>
                              this.handleDateChange(startDate, endDate)
                            }
                            focusedInput={this.state.focusedInput}
                            onFocusChange={(focusedInput) =>
                              this.setState({ focusedInput })
                            }
                            startDatePlaceholderText="Fecha Inicio"
                            endDatePlaceholderText="Fecha Fin"
                            small
                            isOutsideRange={() => false}
                            hideKeyboardShortcutsPanel
                            minimumNights={0}
                          />
                        </Col>
                        <Col md="5">
                          {(this.props.role == roles.SUPER_ADMIN ||
                            this.props.role == roles.ADMIN) && (
                            <Row>
                              <Col sm="4">
                                <Label className="mt-2">TIENDA:</Label>
                              </Col>
                              <Col sm="8">
                                <Select
                                  className="basic-single"
                                  classNamePrefix="select"
                                  isLoading={this.props.loadingStores}
                                  isSearchable={true}
                                  noOptionsMessage={() => {
                                    return messages.SELECT_NO_OPTIONS;
                                  }}
                                  placeholder=""
                                  options={this.props.stores}
                                  loadingMessage={() => {
                                    return messages.SELECT_LOADING;
                                  }}
                                  onChange={this.handleStoreChange.bind(this)}
                                  value={this.state.selectedStore}
                                  isDisabled={this.props.loadingStores}
                                />
                              </Col>
                            </Row>
                          )}
                        </Col>
                        <Col md="3">
                          {this.state.startDate && this.state.endDate ? (
                            <ExportCSV
                              disabled={loadingExport}
                              exportCSV={this.handleObtainSalesExport}
                              minWidth={layout.MD_MIN_WIDTH}
                            />
                          ) : null}
                        </Col>
                      </Row>
                    </div>
                  );
                } else {
                  return (
                    <div>
                      <Row>
                        <Col md="5">
                          {(this.props.role == roles.SUPER_ADMIN ||
                            this.props.role == roles.ADMIN) && (
                            <Row>
                              <Col sm="4">
                                <Label className="mt-2">TIENDA:</Label>
                              </Col>
                              <Col sm="8">
                                <Select
                                  className="basic-single"
                                  classNamePrefix="select"
                                  isLoading={this.props.loadingStores}
                                  isSearchable={true}
                                  noOptionsMessage={() => {
                                    return messages.SELECT_NO_OPTIONS;
                                  }}
                                  placeholder=""
                                  options={this.props.stores}
                                  loadingMessage={() => {
                                    return messages.SELECT_LOADING;
                                  }}
                                  onChange={this.handleStoreChange.bind(this)}
                                  value={this.state.selectedStore}
                                  isDisabled={this.props.loadingStores}
                                />
                              </Col>
                            </Row>
                          )}
                        </Col>
                      </Row>
                      <Row className="mt-2">
                        <Col md="4">
                          <DateRangePicker
                            startDate={startDate}
                            startDateId="startDate"
                            endDate={endDate}
                            endDateId="endDate"
                            displayFormat={"DD/MM/YYYY"}
                            onDatesChange={({ startDate, endDate }) =>
                              this.handleDateChange(startDate, endDate)
                            }
                            focusedInput={this.state.focusedInput}
                            onFocusChange={(focusedInput) =>
                              this.setState({ focusedInput })
                            }
                            startDatePlaceholderText="Fecha Inicio"
                            endDatePlaceholderText="Fecha Fin"
                            small
                            numberOfMonths={1}
                            isOutsideRange={() => false}
                            hideKeyboardShortcutsPanel
                          />
                        </Col>
                        <Col md="3">
                          {this.state.startDate && this.state.endDate ? (
                            <ExportCSV
                              disabled={loadingExport}
                              exportCSV={this.handleObtainEmployeeExport}
                              minWidth={layout.MD_MIN_WIDTH}
                            />
                          ) : null}
                        </Col>
                      </Row>
                    </div>
                  );
                }
              }}
            </MediaQuery>

            <hr className="my-4" />
            {startDate != null && endDate != null ? (
              <div>
                <Row>
                  <Col xl="7">
                    <MediaQuery maxWidth={layout.XS_MAX_WIDTH}>
                      {this.renderDataTable(columns.averageTicketXS)}
                    </MediaQuery>
                    <MediaQuery
                      minWidth={layout.SM_MIN_WIDTH}
                      maxWidth={layout.MD_MAX_WIDTH}
                    >
                      {this.renderDataTable(columns.averageTicketSM)}
                    </MediaQuery>
                    <MediaQuery minWidth={layout.LG_MIN_WIDTH}>
                      {this.renderDataTable(columns.averageTicket)}
                    </MediaQuery>
                  </Col>
                  <Col xl="5">
                    <Bar
                      data={charts.AverageTicketData(
                        this.props.averageTicketChartData
                      )}
                      options={charts.AverageTicketOptions()}
                    />
                  </Col>
                </Row>
              </div>
            ) : (
              <Row>
                <Col>
                  <Alert color="info">
                    Seleccione una fecha para visualizar los datos
                  </Alert>
                </Col>
              </Row>
            )}
          </CardBody>
        </Collapse>
      </Card>
    );
  }
}

function mapStateToProps(state) {
  const { averageTicket, total, error, loading } =
    state.dashboard.averageTicketList;
  return {
    averageTicket,
    total,
    error,
    loading,
    averageTicketChartData: selectAverageTicketData(state),
    role: selectUserRole(state),
    stores: selectStoresForSelect(state),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getAverageTicket,
      getStores,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(CardAverageTicket);



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/CardAverageTicket/CardAverageTicket.js